export default __webpack_public_path__ + "static/media/feedback.dde545ca.svg";